import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, Newspaper, Trophy, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | SheLovesThee</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you're looking for doesn't exist." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-[#00204E] via-[#003366] to-[#00204E] flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          {/* 404 Number */}
          <div className="relative mb-8">
            <span className="text-[150px] sm:text-[200px] font-black text-white/10 leading-none select-none">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-6xl sm:text-8xl font-black text-[#ff9900]">404</span>
            </div>
          </div>

          {/* Message */}
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Page Not Found
          </h1>
          <p className="text-slate-300 mb-8 text-lg">
            Looks like this page fumbled the ball. Let's get you back in the game.
          </p>

          {/* Navigation Options */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto">
            <Link 
              to="/"
              className="flex items-center justify-center gap-2 bg-[#ff9900] hover:bg-[#e68a00] text-white font-bold py-3 px-6 rounded-lg transition-colors"
              data-testid="404-home-link"
            >
              <Home className="w-5 h-5" />
              Go Home
            </Link>
            <Link 
              to="/news"
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-bold py-3 px-6 rounded-lg transition-colors border border-white/20"
              data-testid="404-news-link"
            >
              <Newspaper className="w-5 h-5" />
              Browse News
            </Link>
            <Link 
              to="/swac-pickem"
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-bold py-3 px-6 rounded-lg transition-colors border border-white/20"
              data-testid="404-pickem-link"
            >
              <Trophy className="w-5 h-5" />
              Pick'em
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-bold py-3 px-6 rounded-lg transition-colors border border-white/20"
              data-testid="404-back-btn"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </div>

          {/* Brand */}
          <div className="mt-12 text-slate-400 text-sm">
            SheLovesThee • HBCU Sports Coverage
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
